// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../q-components/q-bpmn/diagram-js.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../q-components/q-bpmn/css/bpmn.css");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../q-components/q-bpmn/css/bpmn-codes.css");
var ___CSS_LOADER_AT_RULE_IMPORT_3___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../q-components/q-bpmn/css/bpmn-embedded.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
exports.push([module.id, ".containers{background-color:#ffffff;width:100%;height:100%}.bjs-powered-by{display:none}.djs-overlay-container{position:inherit !important;width:inherit !important;color:black !important}.bpmn-toolbar{padding-top:15px;padding-left:15px;padding-right:15px}\n", ""]);
// Exports
module.exports = exports;
